module.exports = __webpack_public_path__ + "img/nym-card-background.be61e8c2.png";